<template>
  <div>
    <!-- Toggle não identificado -->
    <div class="custom-control custom-switch mb-3">
      <input
        :id="`person-unidentified-${_uid}`"
        v-model="value.unidentified"
        type="checkbox"
        class="custom-control-input"
        :disabled="disabled"
      >
      <label
        class="custom-control-label"
        :for="`person-unidentified-${_uid}`"
      >
        Não identificado
      </label>
    </div>

    <!-- CPF no topo: chave para reaproveitar cadastro existente (só identificado) -->
    <div
      v-if="!value.unidentified"
      key="person-cpf-row"
      class="row"
    >
      <div class="col-md-5 form-group">
        <label>CPF</label>
        <input
          key="person-cpf"
          v-model="value.cpf"
          v-mask="'###.###.###-##'"
          type="text"
          class="form-control"
          :disabled="disabled"
          placeholder="000.000.000-00"
          @blur="$emit('lookup-key', value.cpf)"
        >
        <small class="text-muted">Preencha para buscar um cadastro já existente.</small>
      </div>
    </div>

    <div
      key="person-main-row"
      class="row"
    >
      <div class="col-md-5 form-group">
        <label>
          <span class="text-danger">*</span>
          {{ value.unidentified ? "Descrição aparente" : "Nome" }}
        </label>
        <input
          v-if="value.unidentified"
          key="person-apparent-description"
          v-model="value.apparent_description"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.name }"
          :disabled="disabled"
          placeholder="Ex: Homem, camiseta azul, aparenta 40 anos"
        >
        <input
          v-else
          key="person-name"
          v-model="value.name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.name }"
          :disabled="disabled"
          placeholder="Nome completo"
        >
        <div
          v-if="errors.name"
          class="invalid-feedback"
        >
          Campo obrigatório.
        </div>
      </div>

      <div class="col-md-4 form-group">
        <label>{{ value.unidentified ? "Idade aparente" : "Idade" }}</label>
        <div class="input-group">
          <input
            v-model.number="value.age"
            type="number"
            class="form-control"
            min="0"
            max="200"
            :disabled="disabled"
            placeholder="Ex: 35"
          >
          <div class="input-group-append">
            <select
              v-model="value.age_unit"
              class="form-control"
              :disabled="disabled"
              style="border-left: 0; border-radius: 0 4px 4px 0"
            >
              <option value="anos">
                anos
              </option>
              <option value="meses">
                meses
              </option>
              <option value="dias">
                dias
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-3 form-group">
        <label>{{ value.unidentified ? "Sexo aparente" : "Sexo" }}</label>
        <select
          v-model="value.gender"
          class="form-control"
          :disabled="disabled"
        >
          <option value="">
            Selecione
          </option>
          <option value="M">
            Masculino
          </option>
          <option value="F">
            Feminino
          </option>
          <option value="O">
            Outro
          </option>
        </select>
      </div>
    </div>

    <template v-if="!value.unidentified">
      <div
        key="person-extra-row"
        class="row"
      >
        <div class="col-md-6 form-group">
          <label>Nome Social</label>
          <input
            v-model="value.social_name"
            type="text"
            class="form-control"
            :disabled="disabled"
            placeholder="Nome social"
          >
        </div>
        <div class="col-md-6 form-group">
          <label>Data de Nascimento</label>
          <input
            v-model="value.birth_date"
            type="date"
            class="form-control"
            :disabled="disabled"
          >
        </div>
        <div class="col-md-4 form-group">
          <label>RG</label>
          <input
            v-model="value.rg"
            type="text"
            class="form-control"
            :disabled="disabled"
            placeholder="RG"
          >
        </div>
        <div class="col-md-4 form-group">
          <label>CNS</label>
          <input
            v-model="value.cns"
            type="text"
            class="form-control"
            :disabled="disabled"
            placeholder="Cartão Nacional de Saúde"
          >
        </div>
        <div class="col-md-4 form-group">
          <label>Raça/Cor</label>
          <input
            v-model="value.race"
            type="text"
            class="form-control"
            :disabled="disabled"
            placeholder="Raça/cor"
          >
        </div>
        <div class="col-md-4 form-group">
          <label>Telefone</label>
          <input
            key="person-telephone"
            v-model="value.telephone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            type="text"
            class="form-control"
            :disabled="disabled"
            placeholder="(00) 0000-0000"
          >
        </div>
        <div class="col-md-4 form-group">
          <label>Celular</label>
          <input
            key="person-cellphone"
            v-model="value.cellphone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            type="text"
            class="form-control"
            :disabled="disabled"
            placeholder="(00) 00000-0000"
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'InvolvedPersonForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
